import React from 'react';
import { formatStringAsCurrency } from '../../../Utils/stringUtils';
import ResultValue from '../../Simple/ResultValue';

export default function StandardPayment(props) {

    return (<>
        <h4>Standard Payment</h4>
        <ResultValue label="120% LTCH Per Diem" value={formatStringAsCurrency(props.result.stdLTCHPerDiem)} />
        <ResultValue label="IPPS Comparable Per Diem" value={formatStringAsCurrency(props.result.stdIPPSComparablePD)} />
        <ResultValue label="Standard Payment - Short Stay Outlier" value={formatStringAsCurrency(props.result.shortStayOutlierPayment)} />
        <ResultValue label="Standard Payment - Full" value={formatStringAsCurrency(props.result.stdPaymentFull)} />
        <ResultValue label="Standard Payment - Outlier" value={formatStringAsCurrency(props.result.outlierPayment)} />
    </>);
}